module.exports = __webpack_public_path__ + "static/aer-logo-2c1ca6b5a55f0ed5710cb4117b4182a6.svg";